import { MoreHorizontal, Pencil, RotateCcw, Trash2 } from "lucide-react";

import { WFPButton } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { getAdministratorFullName } from "../administratorUtils";
import type {
  AdministratorActionHandler,
  AggregatorAdministrator,
  TranslationFunction,
} from "../types";

interface AdministratorActionsMenuProps {
  administrator: AggregatorAdministrator;
  onClickDeleteAdministrator: AdministratorActionHandler;
  onClickEditAdministrator: AdministratorActionHandler;
  onClickEnableAdministrator: AdministratorActionHandler;
  t: TranslationFunction;
}

export const AdministratorActionsMenu = ({
  administrator,
  onClickDeleteAdministrator,
  onClickEditAdministrator,
  onClickEnableAdministrator,
  t,
}: AdministratorActionsMenuProps) => {
  const actionLabel = "Actions";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <WFPButton
          type="button"
          variant="ghost"
          size="icon-sm"
          aria-label={`${actionLabel}: ${getAdministratorFullName(administrator)}`}
        >
          <MoreHorizontal className="size-4" />
        </WFPButton>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {administrator.active ? (
          <>
            <DropdownMenuItem onSelect={() => onClickEditAdministrator(administrator)}>
              <Pencil className="size-4" />
              {t("common.edit")}
            </DropdownMenuItem>
            <DropdownMenuItem
              variant="destructive"
              onSelect={() => onClickDeleteAdministrator(administrator)}
            >
              <Trash2 className="size-4" />
              {t("common.delete")}
            </DropdownMenuItem>
          </>
        ) : (
          <DropdownMenuItem onSelect={() => onClickEnableAdministrator(administrator)}>
            <RotateCcw className="size-4" />
            Enable
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export type { AdministratorActionsMenuProps };
